import { sendToBackgroundViaRelay } from '@plasmohq/messaging';
import { useSearchParams } from 'next/navigation';
import React from 'react';

function NotifyChromeExtensionOnSignOut() {
  const searchParams = useSearchParams();

  React.useEffect(() => {
    const action = searchParams.get('action');
    if (!!action && action === 'sign-out') {
      const refreshTab = async () => {
        try {
          await sendToBackgroundViaRelay({
            name: 'refresh-tab',
            extensionId: 'iifbccjddikdmllicogfkanmdgckjckl', // push to upstash???
          } as any);
        } catch (error) {
          console.error(error);
        }
      };

      refreshTab();
    }
  }, [searchParams]);

  return null;
}

export { NotifyChromeExtensionOnSignOut };
